import React from "react";

const phoneLink = <a href="tel:004956173988840">+49 561 739 888 40</a>,
  mailLink = <a href="mailto:kontakt@newspace-ag.de">kontakt@newspace-ag.de</a>;

const Address = () => {
  return (
    <address>
      new.space AG
      <br />
      Friedrichsstraße 14
      <br />
      34117 Kassel
      <br />
      Telefon: {phoneLink}
      <br />
      E-Mail: {mailLink}
    </address>
  );
};

export default Address;
